import classNames from 'classnames'
import { observer } from 'mobx-react'
import Parallax from '../../../common/Parallax'
import './index.scss'
const ServiceItem2 = observer(
  ({ isDark, dt }: { isDark: boolean; dt: any }) => {
    return (
      <section className={classNames('service-item2', isDark && 'dark')}>
        <div className="service-item2__img">
          <Parallax
            src={dt.src ? dt.src : dt.video}
            type={dt.src ? 'img' : 'video'}
            poster={dt.src ? '' : dt.poster}
            openHere
          />
        </div>
        <div className="service-item2__title">{dt.title}</div>
      </section>
    )
  },
)

export default ServiceItem2
